import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuidesGuard } from './guards/guides/guides.guard';
import { DownloadAppGuard } from './guards/download-app/download-app.guard';

const routes: Routes = [
  {
    path: '', redirectTo: 'tabs', pathMatch: 'full'
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsPageModule),
    canLoad: [GuidesGuard, DownloadAppGuard]
    // canLoad: [GuidesGuard]
  },
  {
    path: 'guide-slides',
    loadChildren: () => import('./pages/guide-slides/guide-slides.module').then( m => m.GuideSlidesPageModule)
  },
  {
    path: 'download-app',
    loadChildren: () => import('./pages/download-app/download-app.module').then( m => m.DownloadAppPageModule)
  },
  {
    path: 'user/:userid',
    loadChildren: () => import('./pages/users/users.module').then( m => m.UsersPageModule)
  },
  {
    path: 'offer/:offerId',
    loadChildren: () => import('./pages/offer/offer.module').then( m => m.OfferPageModule)
  },
  {
    path: 'user', redirectTo: 'tabs', pathMatch: 'full'
  },
  {
    path: 'offer', redirectTo: 'tabs', pathMatch: 'full'
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
